import Loading from './src/loading';

export default Loading;



// WEBPACK FOOTER //
// ./packages/loading/index.js